import { RepeatWrapping, TextureLoader } from 'three'
import { useLoader } from '@react-three/fiber'
import { useMontage } from '../../../../../../context/montage.context'
import { cover } from '../../../../../../utility/constant/helper.constant'
import { Helper, WindowElement } from '../../../../../../classes/helper'

interface Props {
  positionX: number
}

export const WindowsTopGlass = ({ positionX }: Props): JSX.Element => {
  const { measure, roof, ego, night } = useMontage()

  const texture = useLoader(TextureLoader, `texture/glassStruct.png`)

  const { color, opacity } = WindowElement.colorAndOpacity(measure, roof)

  texture.repeat.set(24, 24)
  texture.wrapS = RepeatWrapping
  texture.wrapT = RepeatWrapping

  return (
    <mesh
      position={[
        Helper.convertToMeter(
          measure.userWidth! / 2 -
            measure.windowsTopWidth! / 2 -
            measure.windowsTopWidth! * positionX!
        ),
        Helper.convertToMeter(measure.userHeight!),
        Helper.convertToMeter(measure.userDepth! / 2 + cover.bar.depth / 2),
      ]}
      rotation={[Helper.convertAngleToRadiant(measure.userAngle!), 0, 0]}
    >
      <boxGeometry
        args={[
          Helper.convertToMeter(measure.windowsTopWidth! - 0.01), //? Removes ghost effect
          Helper.convertToMeter(cover.bar.height / 10),
          Helper.convertToMeter(
            measure.userDepth! + +Helper.extendTopElements(measure.userAngle)
          ),
        ]}
      />
      <meshPhysicalMaterial
        color={color}
        map={texture}
        transparent
        opacity={opacity}
        envMapIntensity={ego?.ego || night?.night ? 0.03 : 1}
        roughness={0}
        metalness={1}
      />
    </mesh>
  )
}
